import React from 'react';
import ProfileInfoCardComponent from '../../../components/Cards/Profile/Profile';
import { usePractitioner } from '../../../contexts/practitioner';

const capitalize = (s: string | undefined) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

const ProfileInfoCard = () => {
  const {
    getDisplayName,
    getEmail,
    getFirstName,
    getGender,
    getLastName,
    loading,
  } = usePractitioner();
  return (
    <ProfileInfoCardComponent
      loading={loading}
      displayName={getDisplayName()}
      familyName={getLastName()}
      firstName={getFirstName()}
      gender={capitalize(getGender())}
      email={getEmail() || 'Unknown'}
    />
  );
};
export default ProfileInfoCard;
